// ===============================
// Blog metadata (SEO + layout)
// ===============================
// Featured image shown in the post header (must exist in imageDimensions.ts)
// Author information
// Reviewer information (recommended)
// Publishing dates
// Enables the Table of Contents (generated from h2 / h3)
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const meta = {
  // ===============================
  // Blog metadata (SEO + layout)
  // ===============================
  title: "ARTICLE TITLE",
  description: "Short, SEO-optimized description of the article.",
  slug: "article-slug",
  category: "Primary Category",
  tags: ["tag-1", "tag-2", "tag-3"],
  // Featured image shown in the post header (must exist in imageDimensions.ts)
  featuredImage: {
    src: "/images/blog/HD_1980x1080.webp",
    alt: "Featured image describing the article topic"
  },
  // Author information
  author: {
    name: "Author Name",
    role: "Author Role",
    image: ""
  },
  // Reviewer information (recommended)
  reviewedBy: {
    name: "Reviewer Name",
    role: "Reviewer Role",
    image: ""
  },
  // Publishing dates
  publishedAt: "YYYY-MM-DD",
  updatedAt: "YYYY-MM-DD",
  // Enables the Table of Contents (generated from h2 / h3)
  showTOC: true
};
function _createMdxContent(props) {
  const _components = {
    br: "br",
    code: "code",
    h2: "h2",
    h3: "h3",
    hr: "hr",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CTA, Callout, Image} = _components;
  if (!CTA) _missingMdxReference("CTA", true);
  if (!Callout) _missingMdxReference("Callout", true);
  if (!Image) _missingMdxReference("Image", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: meta.title
    }), "\n", meta.description, "\n", _jsx(_components.hr, {}), "\n", _jsx(Image, {
      src: meta.featuredImage.src,
      alt: meta.featuredImage.alt,
      width: 1980,
      height: 1080,
      priority: true
    }), "\n", _jsx(_components.h2, {
      children: "Key Takeaways"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Main takeaway from the article"
      }), "\n", _jsx(_components.li, {
        children: "Important insight for the reader"
      }), "\n", _jsx(_components.li, {
        children: "Relevant data point for decision-making"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Main Content Section"
    }), "\n", _jsxs(_components.p, {
      children: ["This is where the main blog content begins.", _jsx(_components.br, {}), "\n", "Content should be clean Markdown (avoid inline HTML)."]
    }), "\n", _jsx(_components.h3, {
      children: "Secondary Subsection"
    }), "\n", _jsxs(_components.p, {
      children: ["Subsections (", _jsx(_components.code, {
        children: "h2"
      }), " / ", _jsx(_components.code, {
        children: "h3"
      }), ") are automatically added to the Table of Contents."]
    }), "\n", _jsx(_components.h2, {
      children: "Supporting Image Section"
    }), "\n", _jsx(Image, {
      src: "/images/blog/blogTemplate/auto_insurance_policyholders.png",
      alt: "Infographic highlighting rising auto insurance rates",
      width: 1600,
      height: 2550
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "Important Insight",
      children: _jsx(_components.p, {
        children: "Use this block to highlight warnings, statistics, or key insights."
      })
    }), "\n", _jsx(_components.p, {
      children: "Additional article content goes here..."
    }), "\n", _jsx(_components.h2, {
      children: "Second Supporting Image Section"
    }), "\n", _jsx(Image, {
      src: "/images/blog/blogTemplate/rising_insurance_costs.png",
      alt: "How users respond to rising insurance costs",
      width: 1600,
      height: 2976
    }), "\n", _jsx(_components.p, {
      children: "Additional article content goes here..."
    }), "\n", _jsx(_components.h2, {
      children: "Third Supporting Image Section"
    }), "\n", _jsx(Image, {
      src: "/images/blog/blogTemplate/switchin_usage-based_insurance.png",
      alt: "Adoption of usage-based insurance",
      width: 1600,
      height: 1990
    }), "\n", _jsx(_components.p, {
      children: "Additional article content goes here..."
    }), "\n", _jsx(_components.h2, {
      children: "CTA"
    }), "\n", _jsx(CTA, {
      title: "Compare Auto Insurance Rates",
      description: "Find coverage that fits your needs and budget.",
      buttonText: "Get a Quote",
      href: "/auto-insurance"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
